export default "__VITE_ASSET__O3fxYNMs__"